import React, { Fragment } from 'react';
import { TRunOption } from '../../../api/endpoints/SubsetOption';
import { Day } from '../../../entities/Day';
import { formatRun } from '../../../utils/Format';
import Checkbox from '../../Inputs/Checkbox/Checkbox';
import CheckboxWrap from '../../Ui/CheckboxWrap';
import SelectAllControl from "../SelectAllControl";

const RunsSelector = (props: {
  values: Array<string>;
  spec: TRunOption;
  onChange: (values: Array<string>) => void;
}) => {
  const { spec, values, onChange } = props;

  const options = spec.value.use;

  const onStepCheckboxChange = (value: string, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  };

  return (
    <Fragment>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <CheckboxWrap>
        {
          options.map(option =>
            <Checkbox
              key={option}
              label={formatRun(parseInt(option, 10) as Day)}
              value={option}
              checked={values.includes(option)}
              name="step-ranges"
              onChange={(checked) => onStepCheckboxChange(option, checked)}
            />)
        }
      </CheckboxWrap>
    </Fragment>
  );
};

export default RunsSelector;
